import { render, staticRenderFns } from "./ApplicationSupportModal.vue?vue&type=template&id=585ca3ee&scoped=true"
import script from "./ApplicationSupportModal.vue?vue&type=script&lang=js"
export * from "./ApplicationSupportModal.vue?vue&type=script&lang=js"
import style0 from "./ApplicationSupportModal.vue?vue&type=style&index=0&id=585ca3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ca3ee",
  null
  
)

export default component.exports